"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemSearchQuery = void 0;
class ItemSearchQuery {
    constructor() {
        this.queryParams = {
            view: "search",
        };
    }
    addItemIds(value) {
        // checks if value is not empty
        if (!value) {
            return;
        }
        // check if array exists on queryParams
        if (!Array.isArray(this.queryParams.itemIds)) {
            this.queryParams.itemIds = [];
        }
        // adds itemId(s) to array
        Array.isArray(value)
            ? (this.queryParams.itemIds = this.queryParams.itemIds.concat(value))
            : this.queryParams.itemIds.push(value);
    }
    setLimit(value) {
        this.queryParams.limit = value;
    }
    setOffset(value) {
        this.queryParams.offset = value;
    }
    setCurrencyCode(value) {
        this.queryParams.currencyCode = value;
    }
    setCustomerId(value) {
        this.queryParams.customerId = value;
    }
    setCustomerGroupId(value) {
        this.queryParams.customerGroupId = value;
    }
    setPromotionId(value) {
        this.queryParams.promotionId = value;
    }
    setCategoryId(value) {
        this.queryParams.categoryId = value;
    }
    setOtherFields(data) {
        Object.keys(data)
            .filter((queryKey) => !properties.includes(queryKey))
            .forEach((queryKey) => {
            if (data[queryKey]) {
                this.queryParams[queryKey] = data[queryKey];
            }
        });
    }
    getQueryString() {
        const p = new URLSearchParams();
        Object.keys(this.queryParams).forEach((qp) => {
            if (this.queryParams[qp]) {
                p.append(qp, this.queryParams[qp].toString());
            }
        });
        return p.toString();
    }
}
exports.ItemSearchQuery = ItemSearchQuery;
const properties = [
    "view",
    "itemIds",
    "limit",
    "offset",
    "currencyCode",
    "promotionId",
    "categoryId",
    "customerId",
    "customerGroupId"
];
